import { render, staticRenderFns } from "./VAMdetail.vue?vue&type=template&id=49882184&scoped=true"
import script from "./VAMdetail.vue?vue&type=script&lang=js"
export * from "./VAMdetail.vue?vue&type=script&lang=js"
import style0 from "./VAMdetail.vue?vue&type=style&index=0&id=49882184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49882184",
  null
  
)

export default component.exports